/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { push } from "connected-react-router";
import { bool, number, arrayOf, shape, func } from "prop-types";
// import { Link } from "react-router-dom";
import { isIOS } from "react-device-detect";
import { selectors as sessionSelectors } from "reducers/session";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import { selectors as afipPaymentLinkSelectors, actions as afipPaymentLinkActions } from "reducers/afipPaymentLink";
import { actions as notificationActions } from "reducers/notification";
import ProductList from "pages/_components/product/List";
import GridTable from "pages/_components/GridTable/GridTable";
import Button from "pages/_components/Button";
import * as i18nUtils from "util/i18n";
import CustomData from "pages/_components/CustomData/CustomData";
import CustomText from "pages/_components/CustomText/CustomText";
import FormattedAmount from "pages/_components/FormattedAmount";
import classNames from "classnames";
import ProductSelector from "pages/discounts/DiscountCreation/components/ProductSelector";
import Drawer from "pages/_components/Drawer/Drawer";
import VepsInProgressItem from "./components/ItemRow";
import TitleColumns from "./components/TitleColums";
import FilterForm from "../components/FilterForm";
import Image from "../../_components/Image";
import DeleteVepForm from "./components/DeleteVepForm";

const VepsInProgress = ({
    isDesktop,
    fetching,
    positionTab,
    vepsList,
    vepsFilters,
    hasMoreData,
    accounts,
    activeEnvironment,
}) => {
    const dispatch = useDispatch();
    const [pageNumber, setPageNumber] = useState(1);
    const [selectedVeps, setSelectedVeps] = useState([]);
    const [totalAmountSelected, setTotalAmountSelected] = useState(0);

    const [availableAccounts, setAvailableAccounts] = useState([{ id: "1" }]);
    const [selectedAccount, setSelectedAccount] = useState("");
    const [cuitCreator, setCuitCreator] = useState("");

    const [openEliminarForm, setOpenEliminarForm] = useState(false);
    const [vepToDelete, setVepToDelete] = useState({});
    const [fetchingMoreData, setFetchingMoreData] = useState(false);

    useEffect(() => {
        dispatch(afipPaymentLinkActions.cleanVepsList());
        dispatch(afipPaymentLinkActions.cleanVepFilters());
        dispatch(accountsActions.listAccounts());
    }, []);

    useEffect(() => {
        if (fetching && (vepsList.length === 0 || hasMoreData)) {
            setFetchingMoreData(true);
        } else {
            setFetchingMoreData(false);
        }
    }, [fetching]);

    useEffect(() => {
        if (accounts?.length) {
            const formatOption = (account) => ({
                balance: { currency: account?.currency, quantity: account?.availableBalance },
                currency: account?.currency,
                frequentDestination: null,
                id: account?.productId,
                label: `${i18nUtils.get(`productType.${account?.accountType}`)} ····${account?.accountNumber?.slice(
                    -4,
                )}`,
                minimumPayment: 0,
                permissions: Object.keys(account?.permissions),
                statementsLoan: null,
                totalPayment: 0,
                type: account?.accountType,
                accountNumber: account?.accountNumber,
            });

            setAvailableAccounts(accounts.filter((acc) => acc.currency === "ARS")?.map((acc) => formatOption(acc)));
        }
    }, [accounts]);

    const handleFetchData = (filters) => {
        const { queryType, cuitOrigin } = filters;
        if (queryType === "GENERADO_POR_MI") {
            setCuitCreator(activeEnvironment?.activeUserCuil);
        } else {
            setCuitCreator(cuitOrigin);
        }
        dispatch(afipPaymentLinkActions.cleanVepsList());
        dispatch(afipPaymentLinkActions.setVepFilters(filters));
        dispatch(afipPaymentLinkActions.listVepsPending(filters));
        setSelectedVeps([]);
        setTotalAmountSelected(0);
    };

    const handleOpenEliminarForm = () => {
        setOpenEliminarForm(true);
    };

    const onCloseEliminarForm = () => {
        setOpenEliminarForm(false);
    };

    const fetchMoreTransactions = () => {
        const newPage = pageNumber + 1;
        const newFilters = { ...vepsFilters, pageNumber: newPage };
        setFetchingMoreData(true);
        dispatch(afipPaymentLinkActions.setVepFilters(newFilters));
        dispatch(afipPaymentLinkActions.listVepsPending(newFilters));
        setPageNumber(newPage);
    };

    const handleListReload = () => {
        dispatch(afipPaymentLinkActions.cleanVepsList());
        const newFilters = { ...vepsFilters, pageNumber: 1 };
        setFetchingMoreData(true);
        dispatch(afipPaymentLinkActions.setVepFilters(newFilters));
        dispatch(afipPaymentLinkActions.listVepsPending(newFilters));
        setPageNumber(1);
    };

    const handleSelect = ({ id, value }) => {
        if (value) {
            const idx = vepsList.findIndex((v) => v.id === id);
            if (idx !== -1) {
                const veps = selectedVeps;
                veps.push(vepsList[idx]);
                setSelectedVeps(veps);
                const amount = totalAmountSelected + vepsList[idx].amount;
                setTotalAmountSelected(amount);
            }
        } else {
            const idx = selectedVeps.findIndex((v) => v.id === id);
            if (idx !== -1) {
                const amount = totalAmountSelected - selectedVeps[idx].amount;
                setTotalAmountSelected(amount);
                const veps = selectedVeps;
                veps.splice(idx, 1);
                setSelectedVeps(veps);
            }
        }
    };

    const confirmPayment = () => {
        const account = availableAccounts.filter((a) => a.id === selectedAccount)[0];
        const vepPaymentData = { selectedVeps, totalAmountSelected, account, cuitCreator };
        dispatch(afipPaymentLinkActions.setVepPaymentData(vepPaymentData));
        dispatch(push("/vepPayments/newPayment/confirm"));
    };

    const validAmount = (accountId) => {
        const selected = availableAccounts.find((_account) => _account.id === accountId);
        return totalAmountSelected <= selected?.balance?.quantity;
    };

    const selectAccount = (accountId) => {
        setSelectedAccount(accountId);
        if (!validAmount(accountId)) {
            dispatch(
                notificationActions.showNotification(i18nUtils.get("insuficient.amount.error"), "error", [
                    "vepPayments",
                ]),
            );
        }
    };
    const vepIsChecked = (id) =>
        selectedVeps && selectedVeps.length > 0 && selectedVeps.findIndex((v) => v.id === id) !== -1;

    return (
        <>
            <div className="container py-8">
                <FilterForm isVepInProgress onSubmit={handleFetchData} loading={fetching} />
                <div className="pb-6" />
                {vepsFilters && vepsList.length > 0 ? (
                    <>
                        <ProductList
                            fetchingWithPreviousData
                            fetching={fetching && fetchingMoreData}
                            items={vepsList}
                            noDataText="veps.inProgress.no.results"
                            noFiltersDataText="global.no.results"
                            renderItem={(item, idx) => (
                                <GridTable.Container
                                    key={`vep-in-progress-item-${idx}`}
                                    renderAs="div"
                                    className={!isDesktop && "box box-shadow"}>
                                    <VepsInProgressItem
                                        isChecked={vepIsChecked(item.id)}
                                        vep={item}
                                        // setActionDrawer={() => {}}
                                        isDesktop={isDesktop}
                                        positionTab={positionTab}
                                        handleCheckVep={(val) => handleSelect(val)}
                                        handleOpenEliminarForm={handleOpenEliminarForm}
                                        setVepToDelete={setVepToDelete}
                                    />
                                </GridTable.Container>
                            )}>
                            {(listItem) => (
                                <GridTable className="vep-in-progress-table tablelist received">
                                    {isDesktop && (
                                        <GridTable.Header>
                                            <GridTable.Container>
                                                <TitleColumns />{" "}
                                            </GridTable.Container>
                                        </GridTable.Header>
                                    )}
                                    <GridTable.Body>{listItem}</GridTable.Body>
                                    {hasMoreData && (
                                        <Button
                                            bsStyle="link"
                                            onClick={() => fetchMoreTransactions()}
                                            image="images/figma/icon/arrow.svg"
                                            label="global.showMore"
                                            className="view-more"
                                        />
                                    )}
                                </GridTable>
                            )}
                        </ProductList>
                        {!!selectedVeps.length && (
                            <>
                                <GridTable className="summary-selected-items-table mt-6">
                                    <GridTable.Container columns={3} rows={2}>
                                        <GridTable.Data columnStart={1} rowStart={1} rowWidth={isDesktop ? 2 : 1}>
                                            <div className="discount-bubble-wrapper">
                                                <Image
                                                    src={
                                                        isIOS
                                                            ? "images/figma/icon/success-primary.svg"
                                                            : "images/figma/icon/success.svg"
                                                    }
                                                    className={classNames("svg-icon")}
                                                />
                                                <CustomText
                                                    text={
                                                        selectedVeps.length > 1
                                                            ? `${selectedVeps.length} VEPs seleccionados`
                                                            : `${selectedVeps.length} VEP seleccionado`
                                                    }
                                                />
                                            </div>
                                        </GridTable.Data>
                                        {!isDesktop && (
                                            <GridTable.Data
                                                className={isIOS ? "line-dashed-wrapper" : null}
                                                columnStart={1}
                                                rowStart={2}
                                                columnWidth={2}>
                                                <div className="line-dashed" />
                                            </GridTable.Data>
                                        )}
                                        <GridTable.Data
                                            alignX="end"
                                            columnStart={2}
                                            rowStart={isDesktop ? 1 : 3}
                                            columnWidth={1}>
                                            <CustomText className="" text="Monto total" />
                                        </GridTable.Data>
                                        <GridTable.Data
                                            alignX="end"
                                            columnStart={2}
                                            rowStart={isDesktop ? 2 : 4}
                                            columnWidth={1}>
                                            <FormattedAmount quantity={totalAmountSelected} currency="ARS" />
                                        </GridTable.Data>
                                    </GridTable.Container>
                                </GridTable>
                            </>
                        )}
                        {selectedVeps && selectedVeps.length > 0 && (
                            <div className="grid-table box box-shadow mt-6">
                                <div className="grid-table-row sm:flex md:grid-cols-12">
                                    <div className="grid-table-data md:col-start-2 md:col-span-10">
                                        <ProductSelector
                                            name="debitAccount"
                                            idField="discount-acreditation-account"
                                            label={i18nUtils.get("", "Cuenta de acreditación")}
                                            placeholder={i18nUtils.get(
                                                "deposits.request.filters.debitAccount.placeHolder",
                                                "Seleccioná una cuenta",
                                            )}
                                            data={{ options: availableAccounts || [] }}
                                            onChange={(value) => selectAccount(value)}
                                            value={selectedAccount}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="grid-table form-actions">
                            <div className="grid-table-row sm:flex md:grid-cols-12">
                                <div className="grid-table-data md:col-start-5 md:col-span-4">
                                    <Button
                                        bsStyle="primary"
                                        label="global.continue"
                                        loading={false}
                                        block
                                        onClick={() => confirmPayment()}
                                        disabled={
                                            !selectedVeps.length || !selectedAccount || !validAmount(selectedAccount)
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    vepsFilters && (
                        <div className="box info">
                            <CustomData
                                icon="information_fill.svg"
                                titleText="veps.inProgress.no.results"
                                titleTextType="I18N"
                            />
                        </div>
                    )
                )}
            </div>
            <Drawer
                isDesktop={isDesktop}
                openSidebar={openEliminarForm}
                onClose={onCloseEliminarForm}
                isFullHeight={!isDesktop}
                enableCloseButton={!!isDesktop}>
                <DeleteVepForm
                    isDesktop={isDesktop}
                    handleClose={onCloseEliminarForm}
                    openForm={openEliminarForm}
                    vep={vepToDelete}
                    handleListReload={handleListReload}
                />
            </Drawer>
        </>
    );
};

VepsInProgress.propTypes = {
    isDesktop: bool.isRequired,
    fetching: bool.isRequired,
    positionTab: number.isRequired,
    vepsList: arrayOf(shape({})).isRequired,
    vepsFilters: arrayOf(shape({})).isRequired,
    hasMoreData: bool.isRequired,
    accounts: arrayOf(shape({})).isRequired,
    activeEnvironment: shape({}),
};

VepsInProgress.defaultProps = {
    activeEnvironment: null,
};

const mapStateToProps = (state) => ({
    fetching: afipPaymentLinkSelectors.getFetching(state),
    vepsList: afipPaymentLinkSelectors.getVeps(state),
    vepsFilters: afipPaymentLinkSelectors.getFilters(state),
    hasMoreData: afipPaymentLinkSelectors.getHasMoreData(state),
    accounts: accountsSelectors.getAccounts(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
});

export default connect(mapStateToProps)(VepsInProgress);
